import { ViewClearanceFormModal } from "../view-clearance-form-modal/view-clearance-form-modal.tsx";
import type { OffboardingSource } from "../../types.ts";

export interface ViewResignationFormModalProps {
    open: boolean;
    onClose: () => void;
    offboardingId: number;
    source?: OffboardingSource;
}

export function ViewResignationFormModal({
    open,
    onClose,
    offboardingId,
    source = "REGULAR",
}: ViewResignationFormModalProps) {
    return (
        <ViewClearanceFormModal
            open={open}
            onClose={onClose}
            offboardingId={offboardingId}
            source={source}
            sectionType="RESIGNATION"
            title="Offboarding Request Form"
        />
    );
}
